var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1120,
    height: 19,
    viewBox: "0 0 1120 19",
    preserveAspectRatio: "none",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M118.4 10.6875V8.3125H124.8V10.6875M108.8 10.6875V8.3125H115.2V10.6875M99.2 10.6875V8.3125H105.6V10.6875M128 19V0H96V19H128Z",
    fill: "#069987",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4 10.6875V8.3125H92.8V10.6875M76.8 10.6875V8.3125H83.2V10.6875M67.2 10.6875V8.3125H73.6V10.6875M96 19V0H64V19H96Z",
    fill: "#069987",
    fillOpacity: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4 10.6875V8.3125H60.8V10.6875M44.8 10.6875V8.3125H51.2V10.6875M35.2 10.6875V8.3125H41.6V10.6875M64 19V0H32V19H64Z",
    fill: "#069987",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4 10.6875V8.3125H28.8V10.6875M12.8 10.6875V8.3125L19.2 8.3125V10.6875M3.2 10.6875L3.2 8.3125H9.6V10.6875M32 19V0H0L0 19H32Z",
    fill: "#069987",
    fillOpacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M246.4 10.6875V8.3125H252.8V10.6875M236.8 10.6875V8.3125H243.2V10.6875M227.2 10.6875V8.3125H233.6V10.6875M256 19V0H224V19H256Z",
    fill: "#069987",
    fillOpacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M214.4 10.6875V8.3125H220.8V10.6875M204.8 10.6875V8.3125H211.2V10.6875M195.2 10.6875V8.3125H201.6V10.6875M224 19V0H192V19H224Z",
    fill: "#069987",
    fillOpacity: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M182.4 10.6875V8.3125H188.8V10.6875M172.8 10.6875V8.3125H179.2V10.6875M163.2 10.6875V8.3125H169.6V10.6875M192 19V0H160V19H192Z",
    fill: "#069987",
    fillOpacity: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M150.4 10.6875V8.3125H156.8V10.6875M140.8 10.6875V8.3125H147.2V10.6875M131.2 10.6875V8.3125H137.6V10.6875M160 19V0H128V19H160Z",
    fill: "#069987",
    fillOpacity: 0.3
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M374.4 10.6875V8.3125H380.8V10.6875M364.8 10.6875V8.3125H371.2V10.6875M355.2 10.6875V8.3125H361.6V10.6875M384 19V0H352V19H384Z",
    fill: "#069987",
    fillOpacity: 0.3
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M342.4 10.6875V8.3125H348.8V10.6875M332.8 10.6875V8.3125H339.2V10.6875M323.2 10.6875V8.3125H329.6V10.6875M352 19V0H320V19H352Z",
    fill: "#069987",
    fillOpacity: 0.3
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M310.4 10.6875V8.3125H316.8V10.6875M300.8 10.6875V8.3125H307.2V10.6875M291.2 10.6875V8.3125H297.6V10.6875M320 19V0H288V19H320Z",
    fill: "#069987",
    fillOpacity: 0.3
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M278.4 10.6875V8.3125H284.8V10.6875M268.8 10.6875V8.3125H275.2V10.6875M259.2 10.6875V8.3125H265.6V10.6875M288 19V0H256V19H288Z",
    fill: "#069987",
    fillOpacity: 0.3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M502.4 10.6875V8.3125H508.8V10.6875M492.8 10.6875V8.3125H499.2V10.6875M483.2 10.6875V8.3125H489.6V10.6875M512 19V0H480V19H512Z",
    fill: "#069987",
    fillOpacity: 0.3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M470.4 10.6875V8.3125H476.8V10.6875M460.8 10.6875V8.3125H467.2V10.6875M451.2 10.6875V8.3125H457.6V10.6875M480 19V0H448V19H480Z",
    fill: "#069987",
    fillOpacity: 0.3
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M438.4 10.6875V8.3125H444.8V10.6875M428.8 10.6875V8.3125H435.2V10.6875M419.2 10.6875V8.3125H425.6V10.6875M448 19V0H416V19H448Z",
    fill: "#069987",
    fillOpacity: 0.3
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M406.4 10.6875V8.3125H412.8V10.6875M396.8 10.6875V8.3125H403.2V10.6875M387.2 10.6875V8.3125H393.6V10.6875M416 19V0H384V19H416Z",
    fill: "#069987",
    fillOpacity: 0.3
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M630.4 10.6875V8.3125H636.8V10.6875M620.8 10.6875V8.3125H627.2V10.6875M611.2 10.6875V8.3125H617.6V10.6875M640 19V0H608V19H640Z",
    fill: "#069987",
    fillOpacity: 0.3
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M598.4 10.6875V8.3125H604.8V10.6875M588.8 10.6875V8.3125H595.2V10.6875M579.2 10.6875V8.3125H585.6V10.6875M608 19V0H576V19H608Z",
    fill: "#069987",
    fillOpacity: 0.3
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M566.4 10.6875V8.3125H572.8V10.6875M556.8 10.6875V8.3125H563.2V10.6875M547.2 10.6875V8.3125H553.6V10.6875M576 19V0H544V19H576Z",
    fill: "#069987",
    fillOpacity: 0.3
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M534.4 10.6875V8.3125H540.8V10.6875M524.8 10.6875V8.3125H531.2V10.6875M515.2 10.6875V8.3125H521.6V10.6875M544 19V0H512V19H544Z",
    fill: "#069987",
    fillOpacity: 0.3
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M758.4 10.6875V8.3125H764.8V10.6875M748.8 10.6875V8.3125H755.2V10.6875M739.2 10.6875V8.3125H745.6V10.6875M768 19V0H736V19H768Z",
    fill: "#069987",
    fillOpacity: 0.3
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M726.4 10.6875V8.3125H732.8V10.6875M716.8 10.6875V8.3125H723.2V10.6875M707.2 10.6875V8.3125H713.6V10.6875M736 19V0H704V19H736Z",
    fill: "#069987",
    fillOpacity: 0.3
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M694.4 10.6875V8.3125H700.8V10.6875M684.8 10.6875V8.3125H691.2V10.6875M675.2 10.6875V8.3125H681.6V10.6875M704 19V0H672V19H704Z",
    fill: "#069987",
    fillOpacity: 0.3
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M662.4 10.6875V8.3125H668.8V10.6875M652.8 10.6875V8.3125H659.2V10.6875M643.2 10.6875V8.3125H649.6V10.6875M672 19V0H640V19H672Z",
    fill: "#069987",
    fillOpacity: 0.3
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M886.4 10.6875V8.3125H892.8V10.6875M876.8 10.6875V8.3125H883.2V10.6875M867.2 10.6875V8.3125H873.6V10.6875M896 19V0H864V19H896Z",
    fill: "#069987",
    fillOpacity: 0.3
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M854.4 10.6875V8.3125H860.8V10.6875M844.8 10.6875V8.3125H851.2V10.6875M835.2 10.6875V8.3125H841.6V10.6875M864 19V0H832V19H864Z",
    fill: "#069987",
    fillOpacity: 0.3
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M822.4 10.6875V8.3125H828.8V10.6875M812.8 10.6875V8.3125H819.2V10.6875M803.2 10.6875V8.3125H809.6V10.6875M832 19V0H800V19H832Z",
    fill: "#069987",
    fillOpacity: 0.3
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M790.4 10.6875V8.3125H796.8V10.6875M780.8 10.6875V8.3125H787.2V10.6875M771.2 10.6875V8.3125H777.6V10.6875M800 19V0H768V19H800Z",
    fill: "#069987",
    fillOpacity: 0.3
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1014.4 10.6875V8.3125H1020.8V10.6875M1004.8 10.6875V8.3125H1011.2V10.6875M995.2 10.6875V8.3125H1001.6V10.6875M1024 19V0H992V19H1024Z",
    fill: "#069987",
    fillOpacity: 0.3
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M982.4 10.6875V8.3125H988.8V10.6875M972.8 10.6875V8.3125H979.2V10.6875M963.2 10.6875V8.3125H969.6V10.6875M992 19V0H960V19H992Z",
    fill: "#069987",
    fillOpacity: 0.3
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M950.4 10.6875V8.3125H956.8V10.6875M940.8 10.6875V8.3125H947.2V10.6875M931.2 10.6875V8.3125H937.6V10.6875M960 19V0H928V19H960Z",
    fill: "#069987",
    fillOpacity: 0.3
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M918.4 10.6875V8.3125H924.8V10.6875M908.8 10.6875V8.3125H915.2V10.6875M899.2 10.6875V8.3125H905.6V10.6875M928 19V0H896V19H928Z",
    fill: "#069987",
    fillOpacity: 0.3
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1110.4 10.6875V8.3125H1116.8V10.6875M1100.8 10.6875V8.3125H1107.2V10.6875M1091.2 10.6875V8.3125H1097.6V10.6875M1120 19V0H1088V19H1120Z",
    fill: "#069987",
    fillOpacity: 0.3
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1078.4 10.6875V8.3125H1084.8V10.6875M1068.8 10.6875V8.3125H1075.2V10.6875M1059.2 10.6875V8.3125H1065.6V10.6875M1088 19V0H1056V19H1088Z",
    fill: "#069987",
    fillOpacity: 0.3
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1046.4 10.6875V8.3125H1052.8V10.6875M1036.8 10.6875V8.3125H1043.2V10.6875M1027.2 10.6875V8.3125H1033.6V10.6875M1056 19V0H1024V19H1056Z",
    fill: "#069987",
    fillOpacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoad);
export default __webpack_public_path__ + "static/media/road.fe1f9e377907dd5c8b9650cda9326a63.svg";
export { ForwardRef as ReactComponent };